import React from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

class SelectComponent extends React.Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })).isRequired,
    translationPrefix: PropTypes.string
  }
  static defaultProps = {
    translationPrefix: ''
  }

  handleChange = ({target}) => {
    const {value} = target;
    this.props.onChange(value);
  }

  render() {
    const {translationPrefix} = this.props;
    return (
      <FormControl className="librarylist__formcontrol">
        <InputLabel>{this.props.label}</InputLabel>
        <Select
          name={this.props.name}
          value={this.props.value}
          onChange={this.handleChange}
        >
          {
            this.props.options.map(option => {
              return (
                <MenuItem
                  value={option.id}
                  key={option.id}
                  id={option.id}
                >
                  {translationPrefix ? I18n.t(`${translationPrefix}.${option.label}`) : option.label}
                </MenuItem>
              );
            })
          }
        </Select>
      </FormControl>
    );
  }
}

export default SelectComponent;
